import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngxs/store';
import { of,Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

import { GetUserDetailsAction } from './../../shared/action/account.action';
import { AuthService } from './../../shared/services/auth.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private store = inject(Store);
  private router = inject(Router);
  private authService = inject(AuthService);
  private platformId = inject(PLATFORM_ID);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    this.authService.redirectUrl = state.url;

    // SSR: skip guard on server side
    if (!isPlatformBrowser(this.platformId)) {
      return of(true);
    }

    return this.store.select(s => s.auth?.access_token).pipe(
      // Wait until storage plugin has rehydrated state
      // NGXS storage plugin emits undefined first, then the real value
      filter(token => token !== undefined),
      take(1),
      switchMap(token => {
        if (!token) {
          return of(this.router.createUrlTree(['/auth/login']));
        }
        // Dispatch user details but don't block navigation on it
        this.store.dispatch(new GetUserDetailsAction());
        return of(true as boolean | UrlTree);
      }),
    );
  }


  canActivateChild(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    if (!isPlatformBrowser(this.platformId)) {
      return of(true);
    }

    return this.store.select(s => s.auth?.access_token).pipe(
      filter(token => token !== undefined),
      take(1),
      map(token => {
        if (token) {
          // Already logged in, redirect away from auth pages
          if (
            this.router.url.startsWith('/account') ||
            this.router.url === '/checkout' ||
            this.router.url === '/compare'
          ) {
            return this.router.createUrlTree(['/theme/paris']);
          }
          return false as boolean | UrlTree;
        }
        return true;
      }),
    );
  }
}

